import { FormControl, FormGroup } from '@angular/forms';

import { Product } from './product.model';
import { Warehouse } from './warehouse.model';

export interface InventoryActionProduct {
  id?: number;
  amount: number;
  category_id: number;
  discount_percent: number;
  inventoriable: boolean;
  product: Partial<Product>;
  product_id: number;
  quantity: number;
  unit: string;
  warehouse: Partial<Warehouse>;
  warehouse_id: number;
  extra_params: InventoryActionProductExtraFields;
  _destroy: boolean;
}

export interface InventoryActionProductExtraFields {
  alternative: boolean;
  flexible: boolean;
}

export function toInventoryActionProductForm(inventoryActionProduct: InventoryActionProduct) {
  return new FormGroup({
    id: new FormControl(inventoryActionProduct.id),
    category_id: new FormControl(inventoryActionProduct.category_id),
    product_id: new FormControl(inventoryActionProduct.product_id),
    amount: new FormControl(inventoryActionProduct.amount),
    discount_percent: new FormControl(inventoryActionProduct.discount_percent),
    quantity: new FormControl(inventoryActionProduct.quantity),
    product: new FormGroup({
      name: new FormControl(inventoryActionProduct.product.name),
      code: new FormControl(inventoryActionProduct.product.code),
      brand_name: new FormControl(inventoryActionProduct.product.brand_name),
    }),
    unit: new FormControl(inventoryActionProduct.unit),
    extra_params: new FormGroup({
      alternative: new FormControl(inventoryActionProduct.extra_params?.alternative),
      flexible: new FormControl(inventoryActionProduct.extra_params?.flexible),
    }),
    _destroy: new FormControl(false),
  });
}

export function fromProductToInventoryActionProduct(product: Product, category_id: number): Partial<InventoryActionProduct> {
  return {
    category_id: category_id,
    product_id: product.id,
    amount: product.price,
    discount_percent: product.discount_percent || 0,
    quantity: 1,
    product: {
      name: product.name,
      code: product.code,
      brand_name: product.brand_name,
    },
    unit: product.unit,
    _destroy: false,
  };
}

